import React from "react";
import { SendIcon as MUISend } from "@sscs/ui/icons";
import { ActionMenu } from "Components";
import { PERMISSION } from "Constants";
import { useDialog, useLoginInfo } from "Hooks";
import { useGetWhoamiQuery } from "Services";
import { ActionItem, Member } from "Types";
import EditMember from "../EditMember/EditMember";
import RemoveMember from "../RemoveMember/RemoveMember";
import ResendInvite from "../ResendInvite/ResendInvite";

type OrgMemberActionsProps = {
  member: Member;
};

const OrgMemberActions = ({
  member,
}: OrgMemberActionsProps): React.JSX.Element => {
  const resendInviteDialog = useDialog();
  const editDialog = useDialog();
  const removeDialog = useDialog();
  const { isLocalLogin } = useLoginInfo();

  const { data: whoami } = useGetWhoamiQuery();

  const actions: ActionItem[] = [
    {
      text: "Edit member",
      type: "EDIT",
      isDisabled: !isLocalLogin,
      onClick: editDialog.open,
      permissions: [PERMISSION.MODIFY_MEMBERS_ORGANIZATION_ROLE],
    },
    {
      text: "Remove from organization",
      type: "DELETE",
      onClick: removeDialog.open,
      permissions: [PERMISSION.MODIFY_MEMBERS_ORGANIZATION_ROLE],
      isDisabled: whoami?.user_id === member.user_id,
    },
  ];

  if (member.status === "invited" && isLocalLogin) {
    actions.push({
      text: "Resend invite",
      type: "CUSTOM",
      onClick: resendInviteDialog.open,
      permissions: [PERMISSION.MODIFY_MEMBERS_ORGANIZATION_ROLE],
      itemIcon: <MUISend />,
    });
  }

  return (
    <>
      <ActionMenu items={actions} />
      <ResendInvite
        member={member}
        isOpen={resendInviteDialog.isOpen}
        onClose={resendInviteDialog.close}
      />
      <EditMember
        initialValues={member}
        isOpen={editDialog.isOpen}
        onClose={editDialog.close}
      />
      <RemoveMember
        member={member}
        isOpen={removeDialog.isOpen}
        onClose={removeDialog.close}
      />
    </>
  );
};

export default OrgMemberActions;
